import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material'

type ConfirmDeleteWorkflowFailureActionDialogProps = {
	name: string
	onConfirm: () => void
	onCancel: () => void
}

export const ConfirmDeleteWorkflowFailureActionDialog = (
	props: ConfirmDeleteWorkflowFailureActionDialogProps,
) => {
	return (
		<>
			<DialogTitle>Confirm Delete Failure Action</DialogTitle>
			<DialogContent>
				<Typography>
					Are you sure that you want to remove the <b>{props.name}</b> failure
					action?
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button color="primary" onClick={props.onCancel}>
					Cancel
				</Button>
				<Button color="primary" variant="contained" onClick={props.onConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</>
	)
}
